import { Component, OnInit } from '@angular/core';
import { environment } from '@env';
import { EnvironmentType } from './library/enums/general/environment.enum';

@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.html',
    styleUrls: ['./app.layout.scss']
})
export class AppLayoutComponent implements OnInit {
    public isTestEnv: boolean;
    ngOnInit() {
        this.isTestEnv =
            environment.environmentType == EnvironmentType.Development ||
            environment.environmentType == EnvironmentType.UAT;
    }
}
